import { page } from '$app/stores';
import type { Unsubscriber } from 'svelte/store';

export function initializeMatomo(): Unsubscriber | undefined {
  if (window.location.hostname === 'impulso.space') {
    var _paq = (window._paq = window._paq || []);
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);
    (function () {
      _paq.push(['setTrackerUrl', 'https://impulso.space/impulso-tra-url']);
      _paq.push(['setSiteId', '1']);
      var d = document,
        g = d.createElement('script'),
        s = d.getElementsByTagName('script')[0];
      g.async = true;
      g.src = 'https://impulso.space/impulso-script-url/';
      if (s.parentNode) {
        s.parentNode.insertBefore(g, s);
      }
    })();

    let isFirstLoad = true;

    return page.subscribe((currentPage) => {
      if (isFirstLoad) {
        isFirstLoad = false;
        return;
      }

      if (window._paq) {
        window._paq.push(['setCustomUrl', currentPage.url.pathname]);
        window._paq.push(['setDocumentTitle', currentPage.data.title]);
        window._paq.push(['trackPageView']);
      }
    });
  }
}
